package xyz.malefic.home

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.vh
import xyz.malefic.home.components.sections.BootSequence
import xyz.malefic.home.styles.AppColors
import xyz.malefic.home.util.Boot

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    SilkApp {
        AppColors.Provide(AppColors.default) {
            Surface(SmoothColorStyle.toModifier().minHeight(100.vh)) {
                if (Boot.isBooting) {
                    BootSequence(onFinished = Boot::finish)
                } else {
                    content()
                }
            }
        }
    }
}
